import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login");
            return;
        }
        const session_id = match[1];

        (async () => {
            try {
                const res = await api.post("/auth/session", { session_id });
                setUser(res.data);
                const redirect = sessionStorage.getItem("post_login_redirect") || "/";
                sessionStorage.removeItem("post_login_redirect");
                window.history.replaceState(null, "", window.location.pathname);
                navigate(redirect, { replace: true });
            } catch (e) {
                console.error("Auth failed", e);
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-ink">
            <div className="text-center">
                <div className="inline-block w-10 h-10 border-2 border-gold border-t-transparent rounded-full animate-spin mb-4" />
                <p className="text-gold font-serif text-xl">Accesso in corso...</p>
            </div>
        </div>
    );
}
